export default "__VITE_ASSET__rdSYnph4__"